module.exports = __webpack_public_path__ + "static/media/pencil_icon_large.e1699642.svg";